import { FINAL_TERM_FETCH, FINAL_TERM_UPDATE, FINAL_TERMS_UNLINK } from '../../actions';

const initialState = {
  values: {},
  isLoading: false,
};

function reducerFinalTerm(state = initialState, action: any): typeof initialState {
  switch (action.type) {
    case FINAL_TERM_FETCH: {
      return action.payload;
    }
    case FINAL_TERM_UPDATE: {
      return action.payload;
    }
    case FINAL_TERMS_UNLINK: {
      return action.payload;
    }

    default:
      return state;
  }
}
export default reducerFinalTerm;
